module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#close",
      toString: function () {
        return this.url;
      }
    }